import React, { PropTypes, Component } from 'react';
import FlipMove from 'react-flip-move';
import { connect } from 'react-redux';
import { emojify } from 'react-emojione';

import ChatMessage from './ChatMessage';
import ChatGoals from './ChatGoals';
import ChatWebsite from './ChatWebsite';
import ChatDocument from './ChatDocument';
import ChatQuestionnaire from './ChatQuestionnaire';
import './style.scss';
import { getTimeLastRefresh, getChatItems } from 'selectors';
import { ChatItemShape } from 'entities';

class ChatItems extends Component {

  componentDidUpdate(prevProps) {
    if(prevProps.chatItems.length !== this.props.chatItems.length) {
      this.refs.chatItemsContainer.scrollTop = this.refs.chatItemsContainer.scrollHeight;
    }
  }

  renderChatItems() {
    return this.props.chatItems.map(chatItem => {
      const { chatMessage, chatDocument, chatWebsite, goals, chatQuestionnaire } = chatItem;

      if(chatMessage) {
        return (
          <ChatMessage
            key={chatMessage.id}
            chatMessage={chatMessage}
            avatarImageUrl={chatMessage.fromCounsellor ? this.props.counsellorAvatarImageURL : null}>

            {emojify(chatMessage.text, {output: 'unicode'})}

          </ChatMessage>
        );
      }
      else if(chatDocument) {
        return <ChatDocument key={chatDocument.id} chatDocument={chatDocument} />;
      }
      else if(chatWebsite) {
        return <ChatWebsite key={chatWebsite.id} chatWebsite={chatWebsite}  />;
      }
      else if(goals) {
        return <ChatGoals key="chatGoals" lastRefresh={this.props.lastRefresh} goals={goals} />;
      }
      else if(chatQuestionnaire) {
        return <ChatQuestionnaire key={chatQuestionnaire.id} lastRefresh={this.props.lastRefresh} questionnaire={chatQuestionnaire} />;
      }
    });
  }

  render() {
    return (
      <div className="ChatItems" ref="chatItemsContainer">
        <FlipMove duration={200} enterAnimation="fade" leaveAnimation="fade">
          {this.renderChatItems()}
        </FlipMove>
      </div>
    );
  }
}

ChatItems.propTypes = {
  chatItems: PropTypes.arrayOf(ChatItemShape),
  counsellorAvatarImageURL: PropTypes.string,
  lastRefresh: PropTypes.object
};

const mapStateToProps = state => {
  return {
    chatItems: getChatItems(state),
    lastRefresh: getTimeLastRefresh(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatItems);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/index.js
 **/